import { Targeting } from 'lib/GoogleAds';
import { Targeting as CarGurusTargeting } from 'lib/CarGurusAds';
import { MakeResponse } from 'types/MakeResponse';
import { LocationData } from 'lib/location/Geolocate';
import { FavoriteDataItem } from 'types/Apis/Favorites';
import { Lead } from 'types/Apis/Lead';
import UserData from 'lib/EventLogger/User';
import SuggestiveSellingAdData from './SuggestiveSellingAdData';
import UtmTracking from './UtmTracking';
import FirstVisitTracking from './FirstVisitTracking';
import LeadParams from './Apis/LeadParams';
// Redux store state

export enum RequestStates {
  Unstarted = 'unstarted',
  Finished = 'finished',
  Requested = 'requested',
  Failed = 'failed',
}

export enum AlertTypes {
  Error = 'error',
  Success = 'success',
}

export interface Dialog {
  isShown: boolean;
}

export interface Alert {
  type: AlertTypes;
  message: string;
  uuid: string;
  debug?: string;
}

export interface Slot {
  isEmpty: boolean;
  isSuggestive: boolean;
  elementId: string;
}

export interface AdsSlice {
  adUnit: string | null;
  targeting: Targeting;
  slots: Slot[];
  suggestiveSellingAds: SuggestiveSellingAdData[];
}

export interface CarGurusAdsSlice {
  adUnit: string | null;
  targeting: CarGurusTargeting;
}

export interface SessionSlice {
  hasClosedAdhesionAd: boolean;
  isSignedIn: boolean | undefined;
  isPaid: boolean;
}

// https://redux.js.org/recipes/structuring-reducers/normalizing-state-shape
// We use byVin and allVins to allow for O(1) lookups and maintain order of the favorites
export interface FavoritesSlice {
  byVin: {
    [vin: string]: FavoriteDataItem;
  };
  allVins: string[];
  requestState: RequestStates;
  error?: string;
}

export interface LeadsSlice {
  leads: Lead[];
  error?: string;
}

export type LocationSlice = LocationData | null;

export default interface State {
  user: UserData;
  ads: AdsSlice;
  carGurusAds: CarGurusAdsSlice;
  makesAndModels: MakeResponse[];
  session: SessionSlice;
  favorites: FavoritesSlice;
  leads: LeadsSlice;
  leadSubmissions: LeadParams[];
  alerts: Alert[];
  geolocation: LocationSlice;
  dialog: {
    [name: string]: Dialog;
  };
  utmTracking: UtmTracking;
  firstVisitTracking: FirstVisitTracking;
}
